import { useMatches } from 'react-router';

import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';
import { cmsRouteId } from '#/modules/cms/pages/splat/CmsSplat.horizon-route';
import type { CmsSplatPageLoaderData } from '#/modules/cms/pages/splat/CmsSplatPageLoaderData';

export function useRouteIsCmsApiPage(): CmsApiPage | undefined {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];

  if (lastMatch.id !== cmsRouteId) return;

  const loaderData = lastMatch.data as CmsSplatPageLoaderData;
  if (loaderData?.type !== 'PAGE' && loaderData?.type !== 'POST') return;

  return loaderData.content;
}
